import { t as ApiClient } from "./api-Z2DJpMZ_.js";
import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { QueryClient as QueryClient$1, useQueryClient as useQueryClient$1 } from "react-query";
//#region src/Api/types.ts
function isInstanceOfIErrorPayload(object) {
	return typeof object === "object" && object !== null && "status" in object && "message" in object;
}
//#endregion
//#region src/Api/reactQueryClient.ts
var defaultOptions = { queries: {
	queryFn({ queryKey }) {
		const [endpoint, options] = queryKey;
		const { searchParams } = options ?? {};
		return ApiClient.get(endpoint, { params: searchParams ?? options });
	},
	retry(failureCount, error) {
		return isInstanceOfIErrorPayload(error) && error.status === 500 && failureCount < 3;
	},
	refetchOnWindowFocus: false
} };
var v4DefaultOptions = { queries: {
	queryFn({ queryKey }) {
		const [endpoint, options] = queryKey;
		const { searchParams } = options ?? {};
		return ApiClient.get(endpoint, { params: searchParams ?? options });
	},
	retry(failureCount, error) {
		return isInstanceOfIErrorPayload(error) && error.status === 500 && failureCount < 3;
	},
	refetchOnWindowFocus: false
} };
var reactQueryClient = new QueryClient$1({ defaultOptions });
var v4ReactQueryClient = new QueryClient({ defaultOptions: { ...v4DefaultOptions } });
var useQueryClient$2 = () => {
	const reactQueryClientLocal = useQueryClient$1();
	const v5QueryClientLocal = useQueryClient();
	return {
		async invalidateQueries({ queryKey }) {
			await Promise.all([reactQueryClientLocal.invalidateQueries({ queryKey }), v5QueryClientLocal.invalidateQueries({ queryKey })]);
		},
		async refetchQueries({ queryKey }, settings) {
			await Promise.all([reactQueryClientLocal.refetchQueries({ queryKey }, settings), v5QueryClientLocal.refetchQueries({ queryKey }, settings)]);
		},
		async removeQueries({ queryKey }) {
			await Promise.all([reactQueryClientLocal.removeQueries({ queryKey }), v5QueryClientLocal.removeQueries({ queryKey })]);
		}
	};
};
//#endregion
export { useQueryClient$2 as n, v4ReactQueryClient as r, reactQueryClient as t };

//# sourceMappingURL=Api-BiHEpcD_.js.map